import { connect } from 'react-redux';
import { update, isUpdating, getError } from 'store/modules/files';
import FileForm from 'components/MediaLibrary/FileForm';

const mapStateToProps = state => ({
  saving: isUpdating(state),
  error: getError(state),
});


const mapDispatchToProps = dispatch => ({
  dispatch,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;
  const { id, ...restOfOwnProps } = ownProps;

  return {
    ...stateProps,
    onSubmit: ({ filename, name }) => dispatch(update(id, { filename, name })),
    ...restOfOwnProps,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(FileForm);
